import CheckBox from 'components/Checkbox';
import { ApiKeyCapabilityEnum } from 'constants/ApiKey';
import { FormikProps } from 'formik';
import { FormSchema } from './types';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/apiKey';

interface CapabilityCheckboxProps {
  capability: ApiKeyCapabilityEnum;
  formikProps: FormikProps<FormSchema>;
}

const CapabilityCheckbox = ({
  capability,
  formikProps,
}: CapabilityCheckboxProps) => {
  const { values, setFieldValue } = formikProps;
  const intl = useMemoTranslations(translations);

  const getLabel = (capability: ApiKeyCapabilityEnum) => {
    if (capability === ApiKeyCapabilityEnum.MEDICINE_EQUIVALENCY)
      return intl.MEDICINE_EQUIVALENCE;
    if (capability === ApiKeyCapabilityEnum.CREATE_APPOINTMENTS)
      return intl.CREATE_APPOINTMENTS;
    if (capability === ApiKeyCapabilityEnum.LIST_APPOINTMENTS)
      return intl.LIST_APPOINTMENTS;
  };

  return (
    <CheckBox
      name={capability}
      value={values.capabilities.some(cap => cap === capability)}
      onClick={value =>
        setFieldValue(
          'capabilities',
          value
            ? [...values.capabilities, capability]
            : values.capabilities.filter(cap => cap !== capability)
        )
      }
    >
      {getLabel(capability)}
    </CheckBox>
  );
};

export default CapabilityCheckbox;
